import * as React from 'react';
import { cn } from '../../lib/utils';
import { gridWidth } from './input';

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size' | 'value'> {
  label?: React.ReactNode;
  error?: string | boolean;
  s?: number;
  m?: number;
  l?: number;
  inputClassName?: string;
  value?: React.SelectHTMLAttributes<HTMLSelectElement>['value'] | null;
  validate?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, s, m, l, className, inputClassName, id, disabled, value, validate: _validate, children, ...props }, ref) => {
    const hasError = Boolean(error);
    const errorMessage = typeof error === 'string' ? error : undefined;

    return (
      <div className={cn('px-1', gridWidth(s, m, l), className)}>
        {label && (
          <label htmlFor={id} className="mb-1 block text-sm font-medium text-foreground">
            {label}
          </label>
        )}
        <select
          id={id}
          ref={ref}
          disabled={disabled}
          value={value === null ? '' : value}
          aria-invalid={hasError || undefined}
          className={cn(
            'browser-default',
            'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors',
            'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
            'disabled:cursor-not-allowed disabled:opacity-50',
            hasError && 'border-destructive focus-visible:ring-destructive',
            inputClassName
          )}
          {...props}
        >
          {children}
        </select>
        {errorMessage && <p className="mt-1 text-xs text-destructive">{errorMessage}</p>}
      </div>
    );
  }
);
Select.displayName = 'Select';

export { Select };
